import { render, staticRenderFns } from "./WrapSlot.vue?vue&type=template&id=027d774a&scoped=true&"
import script from "./WrapSlot.vue?vue&type=script&lang=js&"
export * from "./WrapSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027d774a",
  null
  
)

export default component.exports